__turbopack_context__.v({
  "active": "Default-module__M73vxG__active",
  "bcItm": "Default-module__M73vxG__bcItm",
  "bcLink": "Default-module__M73vxG__bcLink",
  "bcWrpr": "Default-module__M73vxG__bcWrpr",
  "disabled": "Default-module__M73vxG__disabled",
  "ellip": "Default-module__M73vxG__ellip",
  "fullView": "Default-module__M73vxG__fullView",
  "treeItm": "Default-module__M73vxG__treeItm",
});
